import React from "react";
import {
  AI_EXPERIENCES,
  AI_SKILLS,
  AI_LICENSES,
  AI_ACADEMIC_DGREE,
  AI_CERTIFICATES,
  AI_LANGUAGES,
  AI_SALARY_EXPECTATIONS,
} from "../../../../config/constants";
import {
  Paper,
  Grid,
  Typography,
  Button,
  Collapse,
  FormControlLabel,
  Switch,
  Badge,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
    "& .MuiButton-root": { minWidth: 140 },
  },
  typography: {
    direction: "rtl",
  },
  layout: {
    display: "flex",
    flexWrap: "wrap",
  },
  paper: {
    padding: theme.spacing(3),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  buttons: {
    "& > .MuiButton-root": {
      minWidth: 140,
    },
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    display: "flex",
    justifyContent: "space-between",
  },
}));

const AdditionalInformatiion = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const [showFilter, setShowFilter] = React.useState(true);
  return (
    <React.Fragment>
      <Grid container justifyContent="flex-start">
        <Grid item xs={12}>
          <FormControlLabel
            style={{ margin: theme.spacing(1) }}
            label={showFilter ? "הסתר מידע נוסף" : "הצג מידע נוסף"}
            control={
              <Switch
                checked={showFilter}
                onChange={() => setShowFilter(!showFilter)}
                name="checkedB"
                color="secondary"
              />
            }
          />
        </Grid>
      </Grid>
      <Collapse in={showFilter}>
        <div className={clsx(classes.root, classes.layout)}>
          <Grid container spacing={3}>
            <Grid item lg={12} align="right">
              <Paper className={classes.paper}>
                <Typography
                  align="right"
                  variant="h6"
                  color="primary"
                  className={classes.typography}
                >
                  {"מידע נוסף על המועמד"}
                </Typography>
                <div className={classes.buttons}>
                  <Badge
                    color="secondary"
                    badgeContent={props.experienceCount}
                    anchorOrigin={{ vertical: "top", horizontal: "left" }}
                    variant="standard"
                    invisible={!props.experienceCount}
                  >
                    <Button
                      onClick={(event) => props.clicked(event, AI_EXPERIENCES)}
                      variant="outlined"
                      color="primary"
                      id="experience"
                    >
                      ניסיון תעסוקתי
                    </Button>
                  </Badge>
                  <Badge
                    color="secondary"
                    badgeContent={props.skillsCount}
                    anchorOrigin={{ vertical: "top", horizontal: "left" }}
                    variant="standard"
                    invisible={!props.skillsCount}
                  >
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={(event) => props.clicked(event, AI_SKILLS)}
                    >
                      כישורים
                    </Button>
                  </Badge>
                  <Badge
                    color="secondary"
                    badgeContent={props.licensesCount}
                    anchorOrigin={{ vertical: "top", horizontal: "left" }}
                    variant="standard"
                    invisible={!props.licensesCount}
                  >
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={(event) => props.clicked(event, AI_LICENSES)}
                    >
                      רישיון
                    </Button>
                  </Badge>
                  <Badge
                    color="secondary"
                    badgeContent={props.academicDegreeCount}
                    anchorOrigin={{ vertical: "top", horizontal: "left" }}
                    variant="standard"
                    invisible={!props.academicDegreeCount}
                  >
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={(event) =>
                        props.clicked(event, AI_ACADEMIC_DGREE)
                      }
                    >
                      תואר אקדמי
                    </Button>
                  </Badge>
                  <Badge
                    color="secondary"
                    badgeContent={props.certificateCount}
                    anchorOrigin={{ vertical: "top", horizontal: "left" }}
                    variant="standard"
                    invisible={!props.certificateCount}
                  >
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={(event) => props.clicked(event, AI_CERTIFICATES)}
                    >
                      תעודה
                    </Button>
                  </Badge>
                  <Badge
                    color="secondary"
                    badgeContent={props.languagesCount}
                    anchorOrigin={{ vertical: "top", horizontal: "left" }}
                    variant="standard"
                    invisible={!props.languagesCount}
                  >
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={(event) => props.clicked(event, AI_LANGUAGES)}
                    >
                      שפות
                    </Button>
                  </Badge>
                  <Badge
                    color="secondary"
                    badgeContent={props.salaryExpectationsCount}
                    anchorOrigin={{ vertical: "top", horizontal: "left" }}
                    variant="standard"
                    invisible={!props.salaryExpectationsCount}
                  >
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={(event) =>
                        props.clicked(event, AI_SALARY_EXPECTATIONS)
                      }
                    >
                      ציפיות שכר
                    </Button>
                  </Badge>
                </div>
              </Paper>
            </Grid>
          </Grid>
        </div>
      </Collapse>
    </React.Fragment>
  );
};
export default AdditionalInformatiion;
